export const DistributionRoutes = {
    distributions: (origin: string) => `${origin}/distributions`,
    distributionsFilters: (origin: string) => `${origin}/distributions/filters`,
};
